<template>
    <div class="container flex justify-center">
        <div class="w-full xl:w-9/12 flex flex-wrap justify-start py-12">
            <div class="w-full text-center mb-10 md:mb-20">
                <h4 v-if="scores.length" class="text-black font-bold text-2xl">Most people in {{ country }} for {{ questionnaire }}:</h4>
                <h4 v-else class="text-black font-bold text-2xl">No results for {{ questionnaire }} for {{ country }}</h4>
            </div>
            <div v-for="score in scores"
                 class="flex flex-col justify-start w-full sm:w-6/12 lg:w-4/12 mb-6 px-4">
                <div class="flex items-center justify-between mb-4">
                    <p class="text-black text-lg">{{ score.competency }}</p>
                    <p class="text-black text-lg">{{ score.score }}%</p>
                </div>
                <div class="w-full bg-white rounded-full flex justify-between h-2">
                    <span :style="{width: `${score.score}%`}" class="h-2 bg-primary-100 rounded-full"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            country: {
                type: String,
                required: true
            },
            scores: {
                type: Array,
                required: true
            },
            questionnaire: {
                type: String,
                required: true
            },
        },
    }
</script>
